import { render, staticRenderFns } from "./media.vue?vue&type=template&id=fd081ab6&"
import script from "./media.vue?vue&type=script&lang=js&"
export * from "./media.vue?vue&type=script&lang=js&"
import style0 from "./media.vue?vue&type=style&index=0&id=fd081ab6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports